var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltips-info"},[_c('p',[_vm._v("Hi~ 我是小易，AI智能助手")]),_vm._v(" "),_c('p',[_vm._v("我的知识库涵盖了公司所有产品、解决方案、案例、新闻等知识，对公司产品信息、公司动态都了如指掌，快来体验一下吧~")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52510986","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/chat-demo/components/question-tooltips.vue
// module id = null
// module chunks = 